<template>
  <div class="course-detail-page">
    <div style="font-size: 16px;color: #666;margin-bottom: 20px;cursor: pointer" @click="toBack">
      录播课/课程详情
    </div>
    <h1 style="font-size: 24px;margin-bottom: 16px;line-height: 32px;">{{item.title}}</h1>
    <!-- 课程头部信息 -->
    <div class="course-header-card">
      <div class="course-meta">
        <div style="display: flex;flex-direction: row;margin-right: 12px;">
          <img style="min-width: 192px;height: 108px;display: inline-block;margin-right: 16px;" :src="item.cover_path" alt="课程封面" class="course-cover" />
          <div>
            <div class="t1_r_item">
              <p class="t1_r_item_p">{{ item.title }}</p>
              <span :style="{ 'background-color':  utils.getBgColor(item.status), 'color': utils.getCustomColor(item.status)}"
                    class="t1_r_item_span">
                    状态: {{utils.getStatusText(item.status) }} (上课时间: 随到随学)</span>
              <span :style="{ 'color': item.color }" class="t1_r_item_span2">已学:{{ item.progress }}</span>
            </div>
            <p class="course-desc">简介: {{item.introductory}}</p>
          </div>
        </div>
        <div class="progress-container" style="color: #ff904d">
          <el-progress type="circle" :percentage="item.pro" :color="utils.getCustomColor(item.status)" :width="60" :show-text="false">
          </el-progress>
          <span style="position: absolute;top: 30px;left: 20px;">{{ item.progress }}</span>
          <span>学习进度</span>
        </div>
      </div>
      <div v-if="lastStudy && lastStudy.length" >
        <div class="last_study" v-for="(item,index) in lastStudy">
          <div style="display: flex;flex-direction: row">
            <img style="width: 120px;height: 74px;display: inline-block;margin-right: 12px;" :src="item.cover_path" alt="章节封面" class="chapter-cover" />
            <div style="display: flex;justify-content: center;flex-direction: column;">
              <h3 style="font-size: 16px;font-weight: 500;margin-bottom: 8px;">{{item.title}}</h3>
              <p style="color: #666;font-size: 14px;">上次浏览</p>
            </div>
          </div>
          <el-button type="primary" class="continue-btn" @click="continueLearning('',2)">继续学习 GO!</el-button>
        </div>
      </div>
      <div v-else class="last_study2">
        <div></div>
        <el-button type="primary" class="continue-btn" @click="continueLearning('',1)">开始学习 GO!</el-button>
      </div>
    </div>


    <!-- 标签页导航 -->
    <div class="tab-nav-card">
      <el-tabs v-model="activeTab" >
        <el-tab-pane label="课程详情" name="detail" style="font-size: 14px;line-height: 24px;color: #666">
          <span v-html="item.description" class="description"></span>
        </el-tab-pane>
        <el-tab-pane label="课程目录" name="catalog">
          <!-- 课程目录内容 -->
          <div v-if="activeTab === 'catalog'" style="padding: 16px 12px;font-size: 16px;">
            <div v-for="(chapter,i) in chapterList" :key="i" class="chapter_class">
              <!--       章节信息       -->
              <div class="chapter_t" @click="handleChildren(chapter,i)">
                <div>
                  <i v-show="!chapter.IsOpen" class="el-icon-caret-right"></i>
                  <i v-show="chapter.IsOpen" class="el-icon-caret-bottom"></i>
                  <span style="font-size: 16px;">{{chapter.title}}</span>
                  <span style="font-size: 16px;">（ {{chapter.lessons ? chapter.lessons.length : 0}}小节 ）</span>
                </div>
                <span style="font-size: 14px;" v-if="chapter.status == 3">{{utils.getStatusText(chapter.status)}}<i class="el-icon-circle-check"></i></span>
              </div>
              <!--      节信息        -->
              <div v-show="chapter.lessons && chapter.lessons.length && chapter.IsOpen" >
                <div v-for="(lesson, index) in chapter.lessons" :key="index" class="lesson_class" @click="continueLearning(lesson,3)" :style="{backgroundColor:lesson.study_view == '已学完' ? '#fbf2ec':''}">
                  <div style="font-size: 16px;">{{lesson.sort}}、{{lesson.title}}</div>
                  <div style="color: #d8d8d8;display: flex;flex-direction: row;margin-top: 8px;" >
                    <span class="lesson_btn">视频</span>
                    <span style="display: inline-block;margin: 0 16px">|</span>
                    <span style="color: #999">{{lesson.time}}</span>
                    <span style="display: inline-block;margin: 0 16px">|</span>
                    <span style="font-size: 14px;" :style="{color:lesson.status == 1 ? '#999' : '#10B981'}">{{lesson.study_view}}<i v-show="lesson.study_view == '已学完'" class="el-icon-circle-check"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseDetail',
  data() {
    return {
      activeTab: 'catalog',
      activeChapters: ['1'],
      chapterList:[],
      showLearnDialog: false,
      currentLesson: {},
      item: {},
      height: 100,
      lastStudy:{},
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    getDetail(){
      this.$http.get('/api/vodDetail/'+this.$route.query.id).then(res => {
        if(res.data.code == 200){
          let detail = res.data.data.detail
          detail.pro =  (((detail.progress.split('/')[0] / detail.progress.split('/')[1]))*100).toFixed(0) - 0
          this.item = detail
          this.lastStudy = res.data.data.lastStudy
          this.chapterList = res.data.data.chapters
          this.chapterList.map((ele, index) => {
            if(ele){
              ele.IsOpen = true
            }
          })
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    toBack(){
      this.$router.push('/home/children/Videoclass')
    },
    //点击章节展开收起
    handleChildren(chapter,i){
      chapter.IsOpen = !chapter.IsOpen
      this.$set(this.chapterList,i,chapter)
    },
    //跳转观看页面
    continueLearning(lesson,type){
      if(lesson){
        sessionStorage.setItem('startStudy', JSON.stringify(lesson))
      }
      this.$router.push('/VideoPlay?id='+this.item.id + '&type=' + type)
    }
  }
}
</script>

<style scoped>
.course-detail-page {
  padding: 20px;
  background-color: #f8f8f8;
  min-height: calc(100vh - 110px);
}

.course-header-card {
  margin-bottom: 12px;
  padding: 12px;
  background-color: #fff;
}

.course-meta {
  margin-bottom: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.course-cover {
  border-radius: 4px;
}

.course-desc {
  margin-top: 10px;
  line-height: 1.5;
  color: #666;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.progress-container {
  display: flex;
  justify-content: flex-end;
  margin: 10px;
  font-size: 14px;
  flex-direction: column;
  position: relative;
}

.chapter-cover {
  border-radius: 4px;
}

.continue-btn {
  margin-right: 12px;
}

.tab-nav-card {
  margin-bottom: 20px;
  background-color: #fff;
  padding: 12px;
}

.learn-dialog-content {
  display: flex;
  gap: 20px;
}

.video-container {
  flex: 2;
}

.learn-video {
  width: 100%;
  height: 300px;
}

.lesson-info {
  flex: 1;
}
.t1_r_item{
  display: flex;flex-direction: row;margin-bottom: 4px;align-items: center;
}

.t1_r_item_p{
  font-size: 16px;font-weight: 500;color: #333;margin-right: 10px;
}
.t1_r_item_span{
  font-size: 12px;display: inline-block;padding: 5px 8px;border-radius: 4px;margin-right: 10px;
}
.t1_r_item_span2{
  margin-right: 10px;font-size: 14px;
}
.chapter_class{
  margin-top: 8px;
}
.chapter_t{
  background-color: #FBF2EC;
  display: flex;
  align-items: center;
  height: 64px;
  justify-content: space-between;
  padding: 20px 16px;
  color: #333;
  box-sizing: border-box;
  cursor: pointer;
}
.lesson_class{
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
}
.lesson_btn{
  /* 自动布局 */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 8px;
  background: rgba(255, 110, 23, 0.2);
  box-sizing: border-box;
  border: 1px solid #FFAC7A;
  width: 44px;
  height: 22px;
  color: #FF6E17;
  font-size: 12px;
  border-radius: 2px;
}
.last_study{
  background-color: #FFEEE4;padding: 12px;display: flex;align-items: center;justify-content: space-between;
  margin-bottom: 8px;
}
.last_study2{
  padding: 12px;display: flex;align-items: center;justify-content: space-between;
}
.description{
  min-height: calc(100vh - 517px);
  display: inline-block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/children/ClassDetail.vue